/** Member notes for presenting First Step in a meeting (Step 1 Action 5). */
export interface Step1PresentationRecord {
  presentedDate?: string;
  place?: string;
  reflection?: string;
  updatedAt?: string;
}

export const EMPTY_STEP1_PRESENTATION: Step1PresentationRecord = {};

export function normalizeStep1Presentation(
  raw: unknown
): Step1PresentationRecord {
  if (!raw || typeof raw !== 'object') return { ...EMPTY_STEP1_PRESENTATION };
  const o = raw as Record<string, unknown>;
  const trim = (v: unknown) => (typeof v === 'string' ? v.trim() : '');
  const presentedDate = trim(o.presentedDate);
  const place = trim(o.place);
  const reflection = trim(o.reflection);
  const updatedAt = typeof o.updatedAt === 'string' ? o.updatedAt : undefined;
  const hasContent =
    !!(presentedDate || place || reflection);
  if (!hasContent) return {};
  return {
    ...(presentedDate ? { presentedDate } : {}),
    ...(place ? { place } : {}),
    ...(reflection ? { reflection } : {}),
    ...(updatedAt ? { updatedAt } : {}),
  };
}
